import { actionCreator } from '@ardoq/rxbeach';

export const toggleSurveyCompleteCondition = actionCreator(
  '[surveyCompleteCondition] TOGGLE_SURVEY_COMPLETE_CONDITION'
);

export const toggleSurveyIncompleteCondition = actionCreator(
  '[surveyIncompleteCondition] TOGGLE_SURVEY_INCOMPLETE_CONDITION'
);
